import { Component } from '@mycolorway/tao';
import $ from 'jquery';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';

Component('tr-project-kanban-todolist-detail', {
  mixins: [eventListenerMixin],

  properties: {
    guid: String,
    scrollLoadUrl: String,
    projectGuid: String,

    copied: {
      type: Boolean,
      default: false,
    },

    moved: {
      type: Boolean,
      default: false,
    },
  },

  connected() {
    const grid = this.querySelector('tr-todo-grid');
    const newTodoRowTemplate = this.querySelector('#tpl-todolist-todo-row');

    this.scrollLoadTrigger = this.querySelector('tr-scroll-load-trigger');
    this.listenTo(this.scrollLoadTrigger, {
      'tr-scroll-load-trigger:loading': this.loadMore.bind(this),
    });
    this.listenTo(grid, {
      'tr-grid-todo-row:refresh': this.refreshGridTodoRow.bind(this),
      'tr-grid-todo-row:move': this.handleTodoMove.bind(this),
      'tr-grid-subtodo-group:rowSortableEnd': this.handleRowSortableEnd.bind(this),
      'tr-todo-grid:rowSortableEnd': this.handleRowSortableEnd.bind(this),
    });

    this.listenTo(this.querySelector('.link-new-todo'), 'click', () => {
      grid.insertNewTodoRow({
        group: this.querySelector('.grid-group'),
        row: document.importNode(
          newTodoRowTemplate.content, true,
        ).firstElementChild,
      });
    });
  },

  loadMore() {
    const lastTodoRow = this.scrollLoadTrigger.previousElementSibling;

    $.ajax({
      url: this.scrollLoadUrl,
      method: 'get',
      data: { till: lastTodoRow ? lastTodoRow.dataset.closedAt : undefined },
      dataType: 'script',
    });
  },

  handleRowSortableEnd(event) {
    const { item, changed } = event.detail;
    if (!item.guid || !changed) return;

    $.ajax({
      url: `/projects/${this.projectGuid}/todos/${item.guid}/reorder`,
      method: 'post',
      data: {
        list_guid: this.guid,
        prev_todo_guid: item.previousElementSibling ? item.previousElementSibling.guid : '',
        next_todo_guid: item.nextElementSibling ? item.nextElementSibling.guid : '',
      },
    });
  },

  refreshGridTodoRow(event) {
    const todoRow = event.target;

    $.ajax({
      url: `/projects/${this.projectGuid}/list/todo_row`,
      method: 'get',
      data: {
        todo_guid: todoRow.guid,
        group_by: 'todolist',
        group_value: this.guid,
      },
      dataType: 'script',
    });
  },

  showCopiedMessage({ projectName, todolistUrl }) {
    const message = this.querySelector('.copy-action-message');
    message.querySelector('.project-name').textContent = projectName;
    message.querySelector('.todolist-link').href = todolistUrl;
    this.copied = true;
  },

  showMovedMessage({ projectName, todolistUrl }) {
    const message = this.querySelector('.move-action-message');
    message.querySelector('.project-name').textContent = projectName;
    message.querySelector('.todolist-link').href = todolistUrl;
    this.moved = true;
  },

  handleTodoMove({ target, detail }) {
    if (this.guid === detail.todolistGuid) return;
    target.parentNode.removeChild(target);
  },

  disconnected() {
    this.stopListening();
  },
});
